import http from 'utlis/http';

const designProBacked = `${process.env.REACT_APP_BASE_URL}/api/v1`;

export default class DesignReviewService {
  static async updateReview(UUID, currentRecord, setError = () => { }) {
    try {
      const resp = await http.patch(
        `${designProBacked}/project/update_design_review/${UUID}/`,
        {
          extra_data: currentRecord?.extra_data,
          final_feedback: currentRecord?.final_feedback,
        }
      );

      return resp?.data;
    }
    catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      }
      else {
        setError('An error occurred while processing your request. Please try again later.');
      }
    }
  }

  static async getReviewData() {
    const resp = await http.get(`${designProBacked}/user/reviewer/design_review_count/`);

    return resp.data;
  }
}
